import { RestaurantsListRender } from "./RestaurantsListRender";

export default RestaurantsListRender;
